module.exports = __webpack_public_path__ + "img/M855.6d180698.jpg";